module.exports = __webpack_public_path__ + "static/media/dog.246c29ef.svg";